import Accordion from "react-bootstrap/Accordion";
import "./style.css";

const CustomAccordion: React.FC<{
  title: string;
  data: JSX.Element;
  eventKey: string;
  isActive: boolean;
  onClick: () => void;
}> = ({ title, data, eventKey, isActive, onClick }) => {
  return (
    <Accordion activeKey={isActive ? eventKey : null}>
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header onClick={onClick}>{title}</Accordion.Header>
        <Accordion.Body>{data}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CustomAccordion;
